module.exports = __webpack_public_path__ + "img/d011_2.75ac78c6.jpeg";